<template>
  <div
    :title="t('headerTools.help')"
    class="common-header-help"
    v-clickoutside="hidePanel"
    v-if="!isTaiwan"
  >
    <div
      :class="['help-button', { active: visiable }]"
      @click="visiable = !visiable"
    >
      <icon class="help" type="help" size="22"></icon>
    </div>
    <div class="help-panel" v-show="visiable">
      <ul
        class="help-panel-card-list"
        :class="{ twoColumns: isTwoColumnsLayout }"
      >
        <li
          v-for="item of realCardList"
          :key="item.id"
          :track-by="item.id"
          @mouseenter="hover = item.id"
          @mouseleave="hover = false"
          :title="item.name"
          @click="onCardClickhandler(item)"
        >
          <SvgIcon
            :type="hover === item.id ? item.hoverIcon : item.icon"
            :width="item.size"
            :height="item.size"
          />
          <div class="card-name">{{ item.name }}</div>
          <slot name="card-footer" :item="item" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import qs from 'qs'

import Icon from '../../components/icon';
import SvgIcon from '../../components/svg-icon';
import clickoutside from '../../directives/clickoutside';
import i18nHandle from '../../locales';

const EWEI_ID = '13929';
const EWEI_BOX_ID = {
  crm: '35b3e681cac333ea06020237d98e571e',
  dx: '0c4b29ab59c0acd7fe8f819ae61c60e5',
  mk: 'ed23e966a4d8073333843e6f9ac77f0a',
};

const I18N_MAP = {
  guide: i18nHandle.t('help.guide'),
  service: i18nHandle.t('help.service'),
  help: i18nHandle.t('help.help'),
  training: i18nHandle.t('help.training'),
};

export const SUPPORT_URL = 'https://support.okki.com';

export default {
  components: {
    Icon,
    SvgIcon,
  },
  directives: {
    clickoutside,
  },
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
    systemName: {
      type: String,
      required: true,
      default: 'crm',
    },
    guidePath: {
      type: String,
      default: '/onboarding',
    },
    hiddenIds: {
      type: Array,
      default: () => ['guide'],
    },
    planVersion: {
      type: [String, Object],
    },
  },
  data() {
    return {
      visiable: false,
      hover: false,
      cardList: [
        {
          id: 'guide',
          name: I18N_MAP.guide,
          icon: 'common-iconfont-advance',
          hoverIcon: 'common-iconfont-advance-c',
          size: 30,
        },
        {
          id: 'service',
          name: I18N_MAP.service,
          icon: 'common-iconfont-service',
          hoverIcon: 'common-iconfont-service-c',
          size: 30,
        },
        {
          id: 'help',
          name: I18N_MAP.help,
          icon: 'common-iconfont-help',
          hoverIcon: 'common-iconfont-help-c',
          size: 30,
        },
      ],
    };
  },
  computed: {
    realCardList() {
      return this.cardList.filter(item => !this.hiddenIds.includes(item.id));
    },
    isTwoColumnsLayout() {
      return this.realCardList.length > 3;
    },
    isTaiwan() {
      return window.location.host.includes('okki.com');
    },
  },
  methods: {
    onCardClickhandler(app) {
      switch (app.id) {
        case 'service':
          this.openOnlineService();
          break;

        case 'help':
          window.open('https://help.xiaoman.cn');
          break;

        case 'guide':
          window.open(this.guidePath);
          break;

        case 'training':
          window.open('https://training.xiaoman.cn/training');
          break;

        default:
        // console.warn('Unhandled exception', app);
      }
    },
    openOnlineService() {
      const {
        is_trial = 0,
        nickname = '',
        user_id = '',
        client_id = '',
        userId = '',
        email = '',
        family_name = '',
        second_name = '',
        user_language = 'zh-CN',
      } = this.userInfo;
      const languageMap = {
        'zh-CN': 'cn',
        'zh-TW': 'tw',
        en: 'en',
      };
      const planVersionContent = Number(is_trial)
        ? 'OKKI Lucky'
        : encodeURIComponent(
            [this.planVersion.system]
              .concat(this.planVersion.modules)
              .join('&'),
          );
      const visitUrl = encodeURIComponent(location.href);
      const zhichiConfig = {
        email,
        visitUrl,
        uname: email,
        partnerid: userId || user_id,
        locale: languageMap[user_language],
        realname: `${family_name} ${second_name}`,
        customer_fields: JSON.stringify({
          /**
           * 用户ID
           */
          customField2: userId || user_id,
          /**
           * 公司ID
           */
          customField3: client_id,
          /**
           * 版本信息
           */
          customField4: planVersionContent,
        }),
      };
      const openZhichiService = () => {
        window.open(`${SUPPORT_URL}?${qs.stringify(zhichiConfig)}`);
      };

      openZhichiService();
    },
    closeServiceWindow() {
      if (this.serviceWindow && !this.serviceWindow.closed) {
        this.serviceWindow.close();
      }
    },
    hidePanel() {
      this.visiable = false;
    },
    t: i18nHandle.t,
  },
};
</script>

<style lang="scss">
@import '../../assets/styles/_variable';
.common-header-help {
  position: relative;

  .help-button {
    cursor: pointer;
    span {
      margin-right: 8px;
      color: inherit;
      font-size: 14px;
    }

    .help {
      color: #909090;
    }
  }
  .help-panel {
    position: absolute;
    top: calc(#{$layoutHeaderHeight} + -20px);
    right: -12px;
    border-radius: 2px;
    background: #fff;
    box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);

    &::before {
      position: absolute;
      top: -6px;
      right: 16px;
      width: 12px;
      height: 12px;
      background-color: #fff;
      box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.26);
      content: '';
      transform: rotate(45deg);
    }

    &::after {
      position: absolute;
      top: 0;
      right: 10px;
      width: 27px;
      height: 16px;
      background-color: #fff;
      content: '';
    }

    &-card-list {
      display: flex;
      margin: 0;
      padding: 14px 0;
      & > li {
        display: flex;
        display: flex;
        flex-direction: column;
        position: relative;
        box-sizing: border-box;
        width: 126px;
        height: 70px;
        list-style: none;
        cursor: pointer;

        align-items: center;
        justify-content: center;
        border-right: 1px solid #f0f0f0;
        &:last-child {
          border: none;
        }

        .card-name {
          padding-top: 8px;
          color: #5d5d5d;
          font-size: 12px;
          line-height: 20px;
          user-select: none;
        }

        &:hover {
          .card-name {
            color: #2a2a2a;
          }
        }
      }
      &.twoColumns {
        width: 267px;
        padding: 14px;
        flex-wrap: wrap;
        & > li {
          position: relative;
          width: 50%;
          height: 85px;
          border: none;
          &:nth-child(odd) {
            &::before {
              position: absolute;
              top: -1px;
              left: 0;
              content: '';
              width: 100%;
              height: 1px;
              background: #f0f0f0;
            }
            border-right: 1px solid #f0f0f0;
          }
          &:nth-child(even) {
            border-right: none;
            &::after {
              position: absolute;
              bottom: 0;
              left: 0;
              content: '';
              width: 100%;
              height: 1px;
              background: #f0f0f0;
            }
          }
          &:nth-child(1) {
            &::before {
              content: none;
            }
          }
          &:last-child {
            &::after {
              content: none;
            }
          }
        }
      }
    }
  }
}
</style>
